"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubscriptionExtrasResponseModel = void 0;
const core = __importStar(require("../../core"));
const ModerationStatusResponseModel_1 = require("./ModerationStatusResponseModel");
const SubscriptionUsageResponseModel_1 = require("./SubscriptionUsageResponseModel");
exports.SubscriptionExtrasResponseModel = core.serialization.object({
    concurrency: core.serialization.number(),
    convaiConcurrency: core.serialization.property("convai_concurrency", core.serialization.number()),
    convaiCharsPerMinute: core.serialization.property("convai_chars_per_minute", core.serialization.number().optional()),
    convaiAsrCharsPerMinute: core.serialization.property("convai_asr_chars_per_minute", core.serialization.number().optional()),
    forceLoggingDisabled: core.serialization.property("force_logging_disabled", core.serialization.boolean()),
    canRequestManualProVoiceVerification: core.serialization.property("can_request_manual_pro_voice_verification", core.serialization.boolean()),
    canBypassVoiceCaptcha: core.serialization.property("can_bypass_voice_captcha", core.serialization.boolean()),
    moderation: ModerationStatusResponseModel_1.ModerationStatusResponseModel,
    unusedCharactersRolledOverFromPreviousPeriod: core.serialization.property("unused_characters_rolled_over_from_previous_period", core.serialization.number().optional()),
    overusedCharactersRolledOverFromPreviousPeriod: core.serialization.property("overused_characters_rolled_over_from_previous_period", core.serialization.number().optional()),
    usage: SubscriptionUsageResponseModel_1.SubscriptionUsageResponseModel.optional(),
});
